// Copyright 2025 LiveKit, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v1.10.1 with parameter "target=dts+js"
// @generated from file livekit_token_source.proto (package livekit, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { RoomConfiguration } from "./livekit_room_pb.js";

/**
 * @generated from message livekit.TokenSourceRequest
 */
export const TokenSourceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.TokenSourceRequest",
  () => [
    { no: 1, name: "room_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "participant_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "participant_identity", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "participant_metadata", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "participant_attributes", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 6, name: "room_config", kind: "message", T: RoomConfiguration, opt: true },
  ],
);

/**
 * @generated from message livekit.TokenSourceResponse
 */
export const TokenSourceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.TokenSourceResponse",
  () => [
    { no: 1, name: "server_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "participant_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

